import React from 'react';
import { Box, useModal } from '@zen-common/components-base';
import { NamingAssetStore } from '@zen/common-app-parts';
import usePreventAction from '../../utils/usePreventAction';
import FPLayout from '../../components/layouts/FPLayout';
import { VerifyEventForm } from '../../components/IssueCancelVerifyForm';
import VerifyEventResult from './VerifyEventResult';

export default function VerifyEvent() {
  const { show, hide } = useModal();
  const { preventAction } = usePreventAction();
  const { state: naming } = NamingAssetStore.useStore();

  const handleSubmit = async (e) => {
    e && e.preventDefault && e.preventDefault();

    if (preventAction({ checkOffline: false })) return;

    show(() => <VerifyEventResult hide={hide} />);
  };

  return (
    <FPLayout title="Verify by event">
      <Box maxWidth="formsMaxWidth">
        <VerifyEventForm onSubmit={handleSubmit} naming={naming} />
      </Box>
    </FPLayout>
  );
}
